import { render, staticRenderFns } from "./remainServeList.vue?vue&type=template&id=18c7ebfe&scoped=true&"
import script from "./remainServeList.vue?vue&type=script&lang=js&"
export * from "./remainServeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7ebfe",
  null
  
)

export default component.exports